<template>
  <div class="o">
    <div class="section_19 flex-row">
      <el-form :model="filterForm" :inline="true" class="filter-form">
        <div class="filter-form-left">
          <el-form-item label="报价时间：" class="filter-form-item">
          <el-date-picker
            v-model="filterForm.quoteTime"
            type="month"
            placeholder="选择月份"
            format="YYYY-MM"
            value-format="YYYY-MM"
            class="filter-date-picker"
          />
        </el-form-item>
        <el-form-item class="filter-form-item">
          <el-input
            v-model="filterForm.keyword"
            placeholder="请输入厂家、系列、型号…"
            class="filter-input"
            clearable
            prefix-icon="el-icon-search"
          />
        </el-form-item>
        <el-form-item class="filter-form-item">
          <el-select
            v-model="filterForm.region"
            placeholder="全部地区"
            class="filter-select"
          >
            <el-option label="全部地区" value=""></el-option>
            <el-option
              v-for="item in regionOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-form-item">
          <el-select
            v-model="filterForm.quoteType"
            placeholder="全部报价方式"
            class="filter-select"
          >
            <el-option label="全部报价方式" value=""></el-option>
            <el-option
              v-for="item in quoteTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-form-item">
          <div class="text-wrapper_9 flex-col" @click="handleReset" style="cursor: pointer;">
            <span class="text_47">重置</span>
          </div>
        </el-form-item>
      </div>
      <div class="filter-form-item view-btn-box">
          <el-form-item class="filter-form-item">
            <div class="text-wrapper_10">
              <span class="text_48">可查看</span>
              <span class="text_49">{{ quoteCount }}</span>
              <span class="text_50">份报价</span>
            </div>
          </el-form-item>
          <div class="text-wrapper_11 flex-col" @click="handleQuoteTypeQuickFilter('manual')" style="cursor: pointer;">
            <span class="text_51">查看人工报价</span>
          </div>
          <div class="text-wrapper_12 flex-col" @click="handleQuoteTypeQuickFilter('auto')" style="cursor: pointer;">
            <span class="text_52">查看自动报价</span>
          </div>
          <div class="text-wrapper_13 flex-col" @click="handleReset" style="cursor: pointer;">
            <span class="text_53">重置</span>
          </div>
        </div>
      </el-form>
    </div>
    <div class="offer-table-wrapper">
    <el-table :data="data" border ref="table">
      <!-- <lida-table-column label="订货号" prop="articleNo" :min-width="150" /> -->
      <el-table-column type="index" label="序号" width="50" align="center" fixed />
      <lida-table-column label="产品信息" :min-width="600">
        <template #default="scope">
          <div class="product-info-wrapper">
            <div class="product-info-row-1">
              <div class="section_28">
                <span class="text_67">{{ scope.row.brandName || "品牌名" }}</span>
                <span class="text_68">{{ scope.row.productName || "无" }}</span>
                <div class="box_8"></div>
              </div>
            </div>
            <div class="product-info-row-2">
              <div class="text-wrapper_17">
                <span class="text_69">型号：</span>
                <span class="text_70">{{ scope.row.barCode || "无" }}</span>
              </div>
              <div class="text-wrapper_18">
                <span class="text_71">订货号：</span>
                <span class="text_72">{{ scope.row.articleNo || "无" }}</span>
              </div>
              <div class="text-wrapper_19">
                <span class="text_73">面价：</span>
                <span class="text_74">￥{{ scope.row.enterpriseVOList[0].guidePrice || "0" }}</span>
              </div>
            </div>
          </div>
        </template>
      </lida-table-column>
      <!-- <lida-table-column label="品牌" :min-width="180"  align="center">
        <template #default="scope">
          <el-tag>{{scope.row.brandName}}</el-tag>
        </template>
      </lida-table-column> -->
      <!-- <lida-table-column label="商品名称" prop="productName" :min-width="140" align="center" />
      <lida-table-column label="型号" prop="barCode" :min-width="140" align="center" />

      <lida-table-column label="订货号" prop="articleNo" :min-width="140" align="center"/> -->
      <!-- <lida-table-column label="面价" prop="guidePrice">
        <template #default="scope">
          <div>
            ￥{{ scope.row.enterpriseVOList.map((v) => v.guidePrice).join() }}
          </div>
        </template>
      </lida-table-column> -->
      <lida-table-column label="数量" prop="skuQty" :min-width="80" />
      <!-- <lida-table-column label="备注" prop="" /> -->
      <lida-table-column label="最高价" prop="maxPurchasePrice">
        <template #default="scope">
          <div class="max-price-text">￥{{ scope.row.maxPurchasePrice }}</div>
        </template>
      </lida-table-column>
      <lida-table-column label="最低价" prop="minPurchasePrice">
        <template #default="scope">
          <div class="min-price-text">￥{{ scope.row.minPurchasePrice }}</div>
        </template>
      </lida-table-column>
      <lida-table-column :min-width="300" v-for="item in company" :key="item.sellerEnterpriseId">
        <template #header>
          <div class="c-t-head-box">
            <div class="c-t-company-name" :title="item.sellerEnterpriseName">
              {{ item.sellerEnterpriseName }}
            </div>
            <!-- 当前显示的商品中，只要该企业有一个商品存在其他报价，就在企业表头统一提示。 -->
            <el-tag v-if="companyHasMultipleQuotes(item)" type="warning" size="small">
              含多条报价
            </el-tag>
            <el-popover v-if="item.agentList && item.agentList.length" placement="left" width="400" trigger="click">
              <div class="h-tree-box">
                <p class="h-title">代理品牌</p>
                <!-- <el-tree
                  :data="item.agentList"
                  default-expand-all
                  node-key="brandName"
                  ref="tree"
                /> -->
                <p v-for="(v, i) in item.agentList" :key="i">
                  {{ v.brandName }}
                </p>
              </div>
              <template #reference>
                <div class="c-t-labels">
                  <div class="label-wrapper label-agent" v-if="item.isAgent">
                    <span class="label-text">代理</span>
                  </div>
                  <div class="label-wrapper label-proprietary" v-if="item.proprietaryFlag === '1'">
                    <span class="label-text">自营</span>
                  </div>
                  <div class="label-wrapper label-partner" v-if="item.authFlag === '1'" title="平台供应商，客户资源共享合作伙伴">
                    <span class="label-text">合作伙伴</span>
                  </div>
                </div>
              </template>
            </el-popover>
            <div v-else class="c-t-labels">
              <div class="label-wrapper label-agent" v-if="item.isAgent">
                <span class="label-text">代理</span>
              </div>
              <div class="label-wrapper label-proprietary" v-if="item.proprietaryFlag === '1'">
                <span class="label-text">自营</span>
              </div>
              <div class="label-wrapper label-partner" v-if="item.authFlag === '1'" title="平台供应商，客户资源共享合作伙伴">
                <span class="label-text">合作伙伴</span>
              </div>
            </div>
            <img 
              src="@/assets/icons/enquiry/upload.png" 
              class="c-t-upload-icon" 
              @click="() => clickExportOffer(item)"
              title="导出报价单"
            />
          </div>
          <div class=" new-refresh-cart">
            <el-tooltip :content="`${item.sellerEnterpriseName || '企业'}报价次数`" placement="top">
              <div class="c-t-stat-number">{{ getQuoteCount(item) }}</div>
            </el-tooltip>
            <el-tooltip :content="`${item.sellerEnterpriseName || '企业'}采购次数`" placement="top">
              <div class="c-t-stat-number">{{ getPurchaseCount(item) }}</div>
            </el-tooltip>
            <div class="c-t-icon-wrapper c-t-refresh-wrapper" title="刷新">
            <img 
              src="@/assets/icons/enquiry/refresh.png" 
              class="c-t-refresh-icon"
            />
          </div>
          <div class="c-t-icon-wrapper c-t-cart-wrapper" title="加入购物车">
            <img 
              src="@/assets/icons/enquiry/cart-blue.png" 
              class="c-t-cart-icon"
            />
          </div>
          </div>
        </template>
        <template #default="scope">
          <span v-if="item[scope.row.skuId]">
            <div :class="[
              'c',
              getRowClass(
                item[scope.row.skuId].salesPrice,
                scope.row.minPurchasePrice,
                scope.row.maxPurchasePrice
              ),
            ]">
              <!-- 第一行：价格 + 数字框 + 刷新图标 + 购物车图标 -->
              <div class="c-top-row">
                <div class="c-price-box">
                  <el-tooltip
                    placement="top"
                    effect="dark"
                    :disabled="!item[scope.row.skuId].guidePrice || item[scope.row.skuId].guidePrice <= 0"
                  >
                    <template #content>
                      <div class="price-tooltip-content">
                        <div class="price-tooltip-row">
                          <span class="price-tooltip-label">原价：</span>
                          <span class="price-tooltip-value price-original">￥{{ item[scope.row.skuId].guidePrice || 0 }}</span>
                        </div>
                        <div class="price-tooltip-row">
                          <span class="price-tooltip-label">折扣：</span>
                          <span class="price-tooltip-value">{{ getDiscount(item[scope.row.skuId].salesPrice, item[scope.row.skuId].guidePrice) }}</span>
                        </div>
                      </div>
                    </template>
                    <span class="c-price">￥{{ item[scope.row.skuId].salesPrice }}</span>
                  </el-tooltip>
                  <el-tooltip 
                    :content="`库存: ${item[scope.row.skuId].realQuantity != null ? item[scope.row.skuId].realQuantity : 0}`" 
                    placement="top"
                  >
                    <div class="c-number-box">
                      <span class="c-number-value">{{ item[scope.row.skuId].realQuantity != null ? item[scope.row.skuId].realQuantity : 0 }}</span>
                    </div>
                  </el-tooltip>
                </div>
                <div class="c-action-icons">
                  <div 
                    v-if="hasRefreshPermission(item[scope.row.skuId])"
                    class="c-refresh-icon-wrapper" 
                    :title="item[scope.row.skuId].realQuantity != undefined ? `实时库存: ${item[scope.row.skuId].realQuantity}` : '刷新实时库存'"
                    @click="priceRefresh(scope.row, item[scope.row.skuId])"
                  >
                    <img 
                      class="c-refresh-icon" 
                      :src="iconMap.refresh.normal"
                      @mouseenter="handleIconHover($event, 'refresh', true)"
                      @mouseleave="handleIconHover($event, 'refresh', false)"
                    />
                  </div>
                  <!-- 购物车统一经过分流入口：单条报价直接校验添加，多条报价先让用户选择。 -->
                  <div 
                    class="c-cart-icon-wrapper" 
                    :title="hasMultipleQuotes(item[scope.row.skuId]) ? '选择报价加入购物车' : '加入购物车'"
                    @click="handleAddCart(item[scope.row.skuId], scope.row, item)"
                  >
                    <img 
                      class="c-cart-icon" 
                      :src="iconMap.cart.normal"
                      @mouseenter="handleIconHover($event, 'cart', true)"
                      @mouseleave="handleIconHover($event, 'cart', false)"
                    />
                  </div>
                </div>
              </div>
              <!-- itemList 只包含其他报价，条数需加上当前主报价；点击提示与购物车打开同一选择弹窗。 -->
              <div v-if="hasMultipleQuotes(item[scope.row.skuId])" class="quote-choice-tip"
                @click="openModal(item[scope.row.skuId], scope.row, item)">
                <el-tag type="warning" size="small">
                  共 {{ item[scope.row.skuId].itemList.length + 1 }} 条报价 · 点击选择
                </el-tag>
              </div>
              <!-- 第二行：信息图标横向排列 -->
              <div class="c-info-icons-row">
                <div 
                  class="c-info-icon-item" 
                  :title="`数量: ${item[scope.row.skuId].qty}`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap.number.normal"
                    @mouseenter="handleIconHover($event, 'number', true)"
                    @mouseleave="handleIconHover($event, 'number', false)"
                  />
                </div>
                <div 
                  class="c-info-icon-item" 
                  :title="`渠道: ${item[scope.row.skuId].channel}`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap.channel.normal"
                    @mouseenter="handleIconHover($event, 'channel', true)"
                    @mouseleave="handleIconHover($event, 'channel', false)"
                  />
                </div>
                <div 
                  class="c-info-icon-item" 
                  :title="`地区: ${item[scope.row.skuId].shipArea}`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap.address.normal"
                    @mouseenter="handleIconHover($event, 'address', true)"
                    @mouseleave="handleIconHover($event, 'address', false)"
                  />
                </div>
                <div 
                  class="c-info-icon-item" 
                  :title="`折扣: ${item[scope.row.skuId].salesDis}%`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap.discount.normal"
                    @mouseenter="handleIconHover($event, 'discount', true)"
                    @mouseleave="handleIconHover($event, 'discount', false)"
                  />
                </div>
                <div 
                  class="c-info-icon-item" 
                  :title="`报价人: ${item[scope.row.skuId].sellerName}`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap.offerer.normal"
                    @mouseenter="handleIconHover($event, 'offerer', true)"
                    @mouseleave="handleIconHover($event, 'offerer', false)"
                  />
                </div>
                <div 
                  class="c-info-icon-item" 
                  :title="`报价方式: ${item[scope.row.skuId].isNewest === '0' ? '自动报价' : '人工报价'}`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap['price-quotation'].normal"
                    @mouseenter="handleIconHover($event, 'price-quotation', true)"
                    @mouseleave="handleIconHover($event, 'price-quotation', false)"
                  />
                </div>
                <div 
                  class="c-info-icon-item" 
                  :title="`报价时间: ${item[scope.row.skuId].quoteTime}`"
                >
                  <img 
                    class="c-info-icon" 
                    :src="iconMap['quotation-time'].normal"
                    @mouseenter="handleIconHover($event, 'quotation-time', true)"
                    @mouseleave="handleIconHover($event, 'quotation-time', false)"
                  />
                </div>
              </div>
              <!-- <div class="c-item"><span>利润点数:</span>{{item[scope.row.skuId].profitSite}}</div>
								<div class="c-item"><span>面价点数:</span>{{item[scope.row.skuId].guideSite}}</div>
								<div class="c-item"><span>面价:</span>{{item[scope.row.skuId].guidePrice}}</div>
								<div class="c-item"><span>采购折扣 ( % ):</span>{{item[scope.row.skuId].purchaseDis}}</div> -->

              <!-- <div class="c-item"><span>实际利润:</span>{{item[scope.row.skuId].profitC}}</div> -->
            </div>
          </span>
          <div v-else class="no-quote-text">未报价</div>
        </template>
      </lida-table-column>
      <!-- <lida-table-column label="操作" fixed="right">
					<template #default="scope">
						<el-button size="mini" @click="deleteRow(scope.row)" type="text">移除</el-button>
					</template>
				</lida-table-column> -->
    </el-table>
    </div>
    <!-- 弹窗展示同一企业对当前商品的主报价及其他报价，不默认选中，也不在打开时提交购物车。 -->
    <el-dialog v-model="dialogTableVisible" title="选择报价加入购物车" width="70%">
      <p class="quote-dialog-tip">{{ quoteCompanyName }}：该商品有多条报价，请选择其中一条加入购物车。</p>
      <el-table :data="gridData">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column property="salesPrice" label="价格" align="center" />
        <el-table-column property="qty" label="数量" align="center" />
        <el-table-column property="channel" label="渠道" align="center" />
        <el-table-column property="shipArea" label="地区" align="center" />
        <el-table-column property="salesDis" label="折扣" align="center" />
        <el-table-column property="sellerName" label="报价人" align="center" />
        <el-table-column property="name" label="报价方式" align="center">
          <template v-slot="scope">
            {{ scope.row.isNewest === "0" ? "自动报价" : "人工报价" }}
          </template>
        </el-table-column>
        <el-table-column property="quoteTime" label="报价时间" align="center" />
        <el-table-column label="操作" align="center" width="150">
          <template v-slot="scope">
            <!-- 用户点击哪一行，就提交哪一行的报价；所有按钮共用提交状态，避免连续选择导致重复添加。 -->
            <el-button type="primary" size="small" :loading="addingQuote" @click="selectQuote(scope.row)">
              选择并加入
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
  <!-- 添加到采购购物车弹框 -->
  <add-cart-change-num v-model="changeNumShow" @success="addSuccess" :info="activeRow" />
  <!-- 采购购物车 -->
  <add-purchase-order v-model="purchaseCartShow" :data="cartGoods" @delete="deleteCart" @success="createSuccess"
    :inquiryId="inquiryId" />
  <offer-info-dialog ref="offerInfo" type="1" v-model="offerInfoVisible" :data="offerInfoData" :quoteInfos="quoteInfos"
    @success="() => { }" />
  <!-- 右下角悬浮购物车按钮 -->
  <div class="floating-cart" @click="showPurchase">
    <div class="floating-cart-icon">
      <img src="@/assets/icons/enquiry/cart-red.png" alt="购物车" />
      <div class="floating-cart-dot" v-if="cartGoods.length">
        <span>{{ cartGoods.length }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import offerProfitCompute from "@/common/js/offerProfitCompute.js";
import purchaseCartMixins from "../../mixins/purchaseCart.js";
import offerInfoDialog from "../../../mysaleMudule/components/dialog/offerInfo.vue"; // 导出报价单弹窗
import moment from "moment";
import {
  applyOfferFilters,
  buildOfferFilterState,
  getDefaultFilterForm,
} from "./offerInfo2Filter";

import { mapActions } from "vuex";
import { ElMessage } from "element-plus";
import {
  handleTreeData, //处理树形数据
} from "@/common/js/common.js";

export default {
  data() {
    return {
      offerInfoData: [],
      data: [], //表格数据
      company: [],
      content: [],
      total: 0,
      dialog: false,
      dialogTableVisible: false,
      gridData: [],
      quoteCompanyName: "", // 当前选择弹窗所属企业名称，用于说明报价归属，避免跨企业选择时混淆。
      addingQuote: false, // 从实时价格校验开始到购物车请求结束持续锁定，供按钮加载状态和重复提交判断共用。
      quoteInfos: {},
      offerInfoVisible: false,
      filterForm: getDefaultFilterForm(),
      rawData: [],
      rawCompany: [],
      rawSkuKeys: [],
      regionOptions: [],
      quoteTypeOptions: [
        { label: "人工报价", value: "manual" },
        { label: "自动报价", value: "auto" },
      ],
      iconMap: {
        'number': {
          normal: require('@/assets/icons/enquiry/number.png'),
          active: require('@/assets/icons/enquiry/number-active.png')
        },
        'channel': {
          normal: require('@/assets/icons/enquiry/channel.png'),
          active: require('@/assets/icons/enquiry/channel-active.png')
        },
        'address': {
          normal: require('@/assets/icons/enquiry/address.png'),
          active: require('@/assets/icons/enquiry/address-active.png')
        },
        'discount': {
          normal: require('@/assets/icons/enquiry/discount.png'),
          active: require('@/assets/icons/enquiry/discount-active.png')
        },
        'offerer': {
          normal: require('@/assets/icons/enquiry/offerer.png'),
          active: require('@/assets/icons/enquiry/offerer-active.png')
        },
        'price-quotation': {
          normal: require('@/assets/icons/enquiry/price-quotation.png'),
          active: require('@/assets/icons/enquiry/price-quotation-active.png')
        },
        'quotation-time': {
          normal: require('@/assets/icons/enquiry/quotation-time.png'),
          active: require('@/assets/icons/enquiry/quotation-time-active.png')
        },
        'refresh': {
          normal: require('@/assets/icons/enquiry/refresh.png'),
          active: require('@/assets/icons/enquiry/refresh.png')
        },
        'cart': {
          normal: require('@/assets/icons/enquiry/cart-blue.png'),
          active: require('@/assets/icons/enquiry/cart-yellow.png')
        }
      },
      companyStats: {}, // 存储企业的报价和采购次数统计
      isAlive: true,
      initVersion: 0,
    };
  },
  components: {
    offerInfoDialog,
  },
  props: ["info", "inquiryId"],
  mixins: [purchaseCartMixins],
  methods: {
    ...mapActions("purchaseMudule", [
      //'inquiryPurchaseInfo',  //查询条件
      "purchaseCartCreate", //加入采购购物车
      "inquiryInfo", // 获取询价详情（包含报价和采购次数）
    ]),
    ...mapActions("mysaleMudule", [
      "listTreeReq", //获取左边tree数据
      // 'quoteSetUpdate',  //修改非代理设置
      "purchasePage",
      "priceRefreshByQuote",
    ]),

    filterExportOffer(data) {
      data = JSON.parse(JSON.stringify(data || []));
      data.map((item) => {

        item.qty = item.qty || 1; //数量
        item.manufactureDate =
          item.manufactureDate || moment().format("YYYY-MM-DD"); //生产日期
        item.channel = item.channel || "现货"; //渠道
        item.purchasePrice = item.purchasePrice || ""; //采购单价
        item.profitSite = item.profitSite || ""; //利润点数
        item.guideSite = item.guideSite || ""; //面价点数
        item.guidePrice = (item.guidePrice || item.skuGuidePrice || 0).toFixed(
          2
        );
        item.shipArea =
          typeof item.shipArea === "string"
            ? item.shipArea.split(",")
            : item.shipArea || [];
        item.amount = item.qty * Number(item.salesPrice);
        item.numType = "qty";

        return offerProfitCompute(item);
      });
      this.offerInfoData = data;
      this.offerInfoData.forEach((v) => {
        this.num += v.qty * v.salesPrice;
        // console.log(this.num);
      });
    },

    clickExportOffer(v) {
      let obj =
        this.info.forEnterprise.find(
          (e) => e.sellerEnterpriseId === v.sellerEnterpriseId
        );

      let arr = []
      this.info.forSku.forEach(e => {
        if (Array.isArray(e.enterpriseVOList)) {
          e.enterpriseVOList.forEach(b => {
            if (b.sellerEnterpriseId === v.sellerEnterpriseId) {
              arr.push({ ...e, ...b })

              if (Array.isArray(b.itemList)) {
                b.itemList.forEach(m => {
                  arr.push({ ...e, ...m })

                })
              }
            }


          })
        }
      })

      if (Array.isArray(obj.skuVOList)) {

        this.filterExportOffer(arr);
        this.offerInfoVisible = true;
        this.quoteInfos = { ...obj };

      } else {
        ElMessage({
          type: "warning",
          message: "暂无报价单数据",
        });
      }
    },
    /**
     * 判断同一企业对当前商品是否存在多条可选报价。
     * row 是表格当前展示的主报价，itemList 是后端合并企业报价时保留的其他报价。
     * 只有 itemList 是非空数组才需要手动选择；未报价、未返回列表、空列表均不算多条报价。
     */
    hasMultipleQuotes(row) {
      return Array.isArray(row?.itemList) && row.itemList.length > 0;
    },
    /**
     * 判断企业表头是否需要显示多报价标识。
     * 仅按商品 SKU 键检查当前筛选结果中的企业报价，跳过企业名称、统计次数等非商品属性。
     * 筛选后不再显示的商品不会触发表头提示，重置筛选后会随报价数据恢复提示。
     */
    companyHasMultipleQuotes(company) {
      return this.rawSkuKeys.some((skuId) => this.hasMultipleQuotes(company[skuId]));
    },
    /**
     * 打开当前企业、当前商品的报价选择弹窗。
     * row 为主报价，info 为商品行，company 为企业列；此方法仅由多条报价入口调用。
     */
    openModal(row, info, company) {
      // 已有报价正在提交时，不允许切换选择内容，避免提交对象与用户当前看到的企业不一致。
      if (this.addingQuote) return;
      // 主报价必须与 itemList 一起参与选择，否则用户无法选择表格中原本展示的那条报价。
      // 每条报价先复制再计算展示价格和折扣，避免计算过程直接改写表格主报价或其他报价对象。
      // 仅补充商品共有的品牌、SKU，保留各报价自己的 quoteId、itemId、sellerId 和企业 ID。
      this.gridData = [row, ...row.itemList].map((quote) => offerProfitCompute({
        ...quote,
        brandId: info.brandId,
        skuId: info.skuId,
      }));
      this.quoteCompanyName = company.sellerEnterpriseName;
      this.dialogTableVisible = true;
    },
    /**
     * 商品单元格购物车按钮的统一入口。
     * 多条报价只打开弹窗并立即结束，不自动将主报价加入购物车；单条报价沿用直接添加流程。
     */
    handleAddCart(row, info, company) {
      if (this.addingQuote) return;
      if (this.hasMultipleQuotes(row)) {
        this.openModal(row, info, company);
        return;
      }
      this.validateAndAddCart(row);
    },
    /** 用户手动选择一条报价后开始校验和添加，仅添加成功才关闭弹窗，失败时保留列表方便重试。 */
    async selectQuote(row) {
      const success = await this.validateAndAddCart(row);
      if (success) this.dialogTableVisible = false;
    },
    handleReset() {
      this.filterForm = getDefaultFilterForm();
    },
    handleQuoteTypeQuickFilter(quoteType) {
      this.filterForm = {
        ...this.filterForm,
        quoteType: this.filterForm.quoteType === quoteType ? "" : quoteType,
      };
    },
    applyFilters() {
      const result = applyOfferFilters(
        {
          data: this.rawData,
          company: this.rawCompany,
          skuKeySet: this.rawSkuKeys,
        },
        this.filterForm
      );
      this.data = result.data;
      this.company = result.company;
    },
    hasRefreshPermission(quoteInfo) {
      return Boolean(String(quoteInfo?.salesPlatform || "").trim());
    },
    updateQuoteRealtimeData(sellerEnterpriseId, skuId, payload) {
      const companyGroups = [this.rawCompany, this.company];
      companyGroups.forEach((list) => {
        const targetCompany = list.find(
          (item) => item.sellerEnterpriseId === sellerEnterpriseId
        );
        const targetQuote = targetCompany?.[skuId];
        if (targetQuote) {
          Object.assign(targetQuote, payload);
        }
      });
    },
    getDiscount(salesPrice, guidePrice) {
      // 计算折扣：销售价 / 原价
      if (!guidePrice || guidePrice <= 0 || !salesPrice || salesPrice <= 0) {
        return "0";
      }
      const discount = (Number(salesPrice) / Number(guidePrice)).toFixed(2);
      return discount;
    },
    getRowClass(currentPrice, minPrice, maxPrice) {
      // 将价格转换为数字进行比较，避免浮点数精度问题
      const current = Number(currentPrice) || 0;
      const min = Number(minPrice) || 0;
      const max = Number(maxPrice) || 0;
      
      // 如果当前价格等于最高价，返回 maxPrice（淡红色背景）
      // 如果当前价格等于最低价，返回 minPrice（淡绿色背景）
      if (current === max && max > 0) {
        return "maxPrice";
      } else if (current === min && min > 0) {
        return "minPrice";
      }
      return "";
    },
    /**
     * 校验指定报价后加入购物车，返回布尔值供选择弹窗判断是否关闭。
     * 单条直接添加与多条手动选择共用此流程，保证两种入口使用一致的校验和提交规则。
     */
    async validateAndAddCart(row) {
      // 锁定整个异步流程，不能只在购物车请求阶段锁定，否则价格校验期间仍可能重复点击。
      if (this.addingQuote) return false;
      this.addingQuote = true;
      try {
        // 按选中报价自身的报价单 ID 查询对应供应商，不能借用商品行或企业其他报价的 ID。
        const res = await this.priceRefreshByQuote({ quoteId: row.quoteId, skuId: row.skuId });
        // 页面已卸载或校验未成功时终止，不再发起购物车请求。
        if (!this.isAlive || res?.data?.code !== "0") return false;
        return await this.addCart(row);
      } catch (error) {
        // 请求异常时保留选择弹窗；页面已卸载则不再弹出提示。
        if (this.isAlive) {
          ElMessage({ type: "error", message: "加入购物车失败，请稍后重试" });
        }
        return false;
      } finally {
        // 成功、业务失败、网络异常都要释放提交锁，使用户可以继续操作或重试。
        this.addingQuote = false;
      }
    },
    /**
     * 将指定报价提交到采购购物车。
     * 所有报价相关参数从同一个 row 读取，避免混用商品行 ID、企业首条报价的报价人或其他明细。
     */
    addCart(row) {
      return this.purchaseCartCreate({
        inquiryId: row.inquiryId || this.inquiryId, //询价单id
        purchasePrice: row.salesPrice, //采购单价(销售价)
        purchaseQty: 1, // 沿用商品单元格添加时默认采购 1 件的规则，不把供应商的报价数量作为采购数量。
        quoteId: row.quoteId, //报价单id
        sellerId: row.sellerId, //卖家id
        sellerEnterpriseId: row.sellerEnterpriseId,
        skuId: row.skuId,
        quoteItemId: row.itemId, // 选中报价的明细 ID，与该行 quoteId、sellerId 对应。
        remarks: "", //备注
      }).then((res) => {
        if (!this.isAlive) return false;
        let { code, data } = res?.data || {};
        if (code === "0") {
          if(data == 1){
            ElMessage({
              type: "success",
              message: "添加成功,价格已经变动。请注意！",
            });
          }else{
            ElMessage({
              type: "success",
              message: "添加成功",
            });
          }
          // 添加成功后复用购物车混入的刷新方法，同时向选择弹窗返回成功结果。
          this.addSuccess();
          return true;
        }
        return false;
      });
    },
    init() {
      // 询价详情重新加载时清空旧报价选择，避免弹窗继续持有刷新前的报价数据。
      this.dialogTableVisible = false;
      this.gridData = [];
      const initVersion = ++this.initVersion;
      const state = buildOfferFilterState(
        this.info?.forSku || [],
        offerProfitCompute
      );
      this.rawData = state.data;
      this.rawCompany = state.company;
      this.rawSkuKeys = state.skuKeySet;
      this.regionOptions = state.regionOptions;
      this.applyFilters();
      
      // 页面加载时自动获取所有库存数据
      this.refreshAllStock(initVersion);
      
      // 获取企业的报价和采购次数统计
      this.getCompanyStats(initVersion);
    },
    
    /** 获取企业的报价和采购次数统计 */
    getCompanyStats(initVersion) {
      // 调用询价详情接口获取统计数据
      this.inquiryInfo({
        inquiryId: this.inquiryId
      }).then((res) => {
        if (!this.isAlive || initVersion !== this.initVersion) {
          return;
        }
        const { code, data } = res.data;
        if (code === "0" && data && data.forEnterprise) {
          // 将企业统计数据更新到 company 数组中
          data.forEnterprise.forEach((enterprise) => {
            const companyItem = this.company.find(
              (c) => c.sellerEnterpriseId === enterprise.sellerEnterpriseId
            );
            if (companyItem) {
              companyItem.quoteNum = enterprise.quoteNum || 0;
              companyItem.purchaseNum = enterprise.purchaseNum || 0;
            }
            const rawCompanyItem = this.rawCompany.find(
              (c) => c.sellerEnterpriseId === enterprise.sellerEnterpriseId
            );
            if (rawCompanyItem) {
              rawCompanyItem.quoteNum = enterprise.quoteNum || 0;
              rawCompanyItem.purchaseNum = enterprise.purchaseNum || 0;
            }
          });
        }
      }).catch((e) => {
        if (!this.isAlive || initVersion !== this.initVersion) {
          return;
        }
        console.error('获取企业统计数据失败', e);
      });
    },
    
    /** 刷新所有商品的库存数据 */
    refreshAllStock(initVersion) {
      this.data.forEach((item) => {
        this.company.forEach((companyItem) => {
          const skuData = companyItem[item.skuId];
          if (skuData && skuData.quoteId && this.hasRefreshPermission(skuData)) {
            // 调用刷新接口
            this.priceRefreshByQuote({
              quoteId: skuData.quoteId || item.quoteId,
              skuId: item.skuId
            }).then((res) => {
              if (!this.isAlive || initVersion !== this.initVersion) {
                return;
              }
              if (!res?.data) {
                return;
              }
              let dataVO = res.data;
              if (dataVO.code === "0") {
                const nextPayload = {};
                if (dataVO.data.realPrice && dataVO.data.realPrice > 0) {
                  nextPayload.salesPrice = (dataVO.data.realPrice / 100).toFixed(2);
                }
                // 无论 realPrice 是否有值，都设置 quantity
                nextPayload.realQuantity =
                  dataVO.data.quantity != null ? dataVO.data.quantity : 0;
                this.updateQuoteRealtimeData(
                  companyItem.sellerEnterpriseId,
                  item.skuId,
                  nextPayload
                );
              }
            }).catch((e) => {
              if (!this.isAlive || initVersion !== this.initVersion) {
                return;
              }
              console.error('获取库存失败', e);
            });
          }
        });
      });
    },
    getTreeList() {
      this.listTreeReq({ type: "DIS_AGENT" }).then((res) => {
        if (!this.isAlive) {
          return;
        }
        let { data, code } = res.data;
        if (code === "0") {
          this.treeList = handleTreeData(data, "categoryName");
        }
      });
    },
    getContent() {
      this.purchasePage({
        pageNo: "1",
        pageSize: "999",
        inquiryId: this.inquiryId,
      }).then((res) => {
        if (!this.isAlive) {
          return;
        }
        this.content = res?.data?.data?.rows || [];
        this.total = res?.data?.data?.totalCount ?? res?.data?.totalCount ?? 0;
      }).catch((e) => {
        if (!this.isAlive) {
          return;
        }
        console.error("获取采购记录失败", e);
      });
    },
    changcurrent(val) {
      this.pageNo = val;
      this.dialog = false;
    },
    /** 价格实时刷新 */
    priceRefresh(row, subItem){
      if (!this.hasRefreshPermission(subItem)) {
        return;
      }
      const that = this
      this.priceRefreshByQuote({quoteId:subItem.quoteId || row.quoteId, skuId:row.skuId}).then(
        (res)=>{
          if (!this.isAlive) {
            return;
          }
          if(!res?.data){
            return
          }
          let dataVO = res.data
          if(dataVO.code === "0"){
            const nextPayload = {};
            if(dataVO.data.realPrice && dataVO.data.realPrice > 0){
              nextPayload.salesPrice = (dataVO.data.realPrice/100).toFixed(2);
            }
            // 无论 realPrice 是否有值，都设置 quantity
            nextPayload.realQuantity =
              dataVO.data.quantity != null ? dataVO.data.quantity : 0;
            this.updateQuoteRealtimeData(
              subItem.sellerEnterpriseId,
              row.skuId,
              nextPayload
            );
          }
        }
      )
    },
    /** 处理图标 hover 状态 */
    handleIconHover(event, iconName, isHover) {
      const img = event.target;
      const iconConfig = this.iconMap[iconName];
      if (iconConfig) {
        img.src = isHover ? iconConfig.active : iconConfig.normal;
      }
    },
    /** 获取企业的报价次数 */
    getQuoteCount(item) {
      const enterprise = this.info?.forEnterprise?.find(
        (enterpriseItem) =>
          String(enterpriseItem.sellerEnterpriseId) ===
          String(item.sellerEnterpriseId)
      );
      return enterprise?.quoteNum || 0;
    },
    /** 获取企业的采购次数 */
    getPurchaseCount(item) {
      const enterprise = this.info?.forEnterprise?.find(
        (enterpriseItem) =>
          String(enterpriseItem.sellerEnterpriseId) ===
          String(item.sellerEnterpriseId)
      );
      return enterprise?.purchaseNum || 0;
    }
  },
  computed: {
    quoteCount() {
      const skuKeySet = new Set(this.rawSkuKeys || []);
      return this.company.reduce((count, item) => {
        return count + Object.keys(item).filter((key) => skuKeySet.has(String(key))).length;
      }, 0);
    },
  },
  created() {
    this.init();
    this.getContent();
  },
  beforeUnmount() {
    this.isAlive = false;
    this.initVersion++;
  },
  watch: {
    info() {
      this.init();
    },
    filterForm: {
      handler() {
        this.applyFilters();
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="less">
/* 多报价入口位于价格行和信息图标之间，仅文字标签区域可点击，避免扩展到整个报价单元格。 */
.quote-choice-tip {
  margin-bottom: 10px;
  cursor: pointer;
  width: fit-content;
}

/* 弹窗顶部说明与报价列表留出间距，让用户先确认企业归属，再选择具体报价。 */
.quote-dialog-tip {
  margin: 0 0 16px;
  color: #606266;
}

/deep/ .el-dialog {
  padding: 20px;
}

/deep/ .el-table th {
  background-color: #EBEBEB !important;
  border-right: none !important;
}

/deep/ .el-table__header-wrapper th {
  background-color: #EBEBEB !important;
  border-right: none !important;
}

/deep/ .el-table td {
  border-right: none !important;
}

/deep/ .el-table__body-wrapper td {
  border-right: none !important;
}

/* 报价列表按实际数据行撑开，去除表格主体分配出的上下空白。 */
.offer-table-wrapper /deep/ .el-table,
.offer-table-wrapper /deep/ .el-table__inner-wrapper,
.offer-table-wrapper /deep/ .el-table__body-wrapper,
.offer-table-wrapper /deep/ .el-table__fixed-body-wrapper,
.offer-table-wrapper /deep/ .el-table__body {
  height: auto !important;
  min-height: 0 !important;
}

.offer-table-wrapper /deep/ .el-table__body tr {
  height: auto !important;
}

.offer-table-wrapper /deep/ .el-table__body-wrapper .el-scrollbar,
.offer-table-wrapper /deep/ .el-table__body-wrapper .el-scrollbar__wrap,
.offer-table-wrapper /deep/ .el-table__body-wrapper .el-scrollbar__view,
.offer-table-wrapper /deep/ .el-table__body tbody {
  height: auto !important;
  min-height: 0 !important;
}

.offer-table-wrapper /deep/ .el-table__body td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.offer-table-wrapper /deep/ .el-table__body td .cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/deep/ .el-table--border {
  border-right: none !important;
}

/deep/ .el-table--border::after {
  display: none !important;
}

/deep/ .el-table--border::before {
  display: none !important;
}

.label {
  display: inline-block;
  font-size: 12px;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
}

.label-wrapper {
  display: inline-flex;
  align-items: center;
  border-radius: 11px;
  height: 22px;
  width: 43px;
  margin-right: 10px;
  box-sizing: border-box;
  position: relative;
}

.label-text {
  width: 24px;
  height: 17px;
  overflow-wrap: break-word;
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
  margin: 2px 0 0 10px;
}

.label-agent {
  border: 1px solid rgba(232, 171, 33, 1);
  
  .label-text {
    color: rgba(232, 171, 33, 1);
  }
}

.label-proprietary {
  border: 1px solid rgba(58, 141, 239, 1);
  
  .label-text {
    color: rgba(58, 141, 239, 1);
    font-family: PingFangSC-Medium;
    font-weight: 500;
  }
}

.label-partner {
  border: 1px solid rgba(159, 87, 232, 1);
  margin-right: 0;
  width: auto;
  min-width: 43px;
  padding-right: 10px;
  
  .label-text {
    color: rgba(159, 87, 232, 1);
    font-family: PingFangSC-Medium;
    font-weight: 500;
    width: auto;
  }
}

.a {
  padding: 20px;

  .a-title {
    padding-bottom: 20px;
    font-weight: bold;
  }

  .a-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }
}

.o {
  height: 100%;
  overflow-y: auto;
  display: block;

  .o-title {
    padding: 10px 20px 10px 0;
    display: flex;
    justify-content: space-between;

    span {
      color: #d84146;
      font-weight: bold;
      margin: 0 5px;
    }
  }
}

.c {
  box-sizing: border-box;
  padding: 0 10px;
}

.c-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.c-price-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.c-price {
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
}

.c-number-box {
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: 4px;
  padding: 2px 8px;
  min-width: 34px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.c-number-value {
  font-size: 12px;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

.c-action-icons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.c-refresh-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(72, 160, 156, 0.1);
  }
}

.c-refresh-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
}

.c-cart-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(72, 160, 156, 0.1);
  }
}

.c-cart-icon {
  width: 22px;
  height: 22px;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
}

.c-info-icons-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.c-info-icon-item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  position: relative;
}

.c-info-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
}

.isAgent-text {
  color: #d84146;
  font-weight: 900;
  cursor: pointer;
}

.h-tree-box {
  height: 350px;
  overflow-y: auto;

  .h-title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 15px;
    border-radius: 5px;
    background: #f2f5fa;
  }
}

.minPrice {
  background-color: rgba(237, 250, 241, 1);
  color: rgba(51, 51, 51, 1);
}

.no-quote-text {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: 56px;
  height: 22px;
  margin: 0 auto;
  padding: 0 10px;
  border: 1px solid rgba(218, 222, 222, 1);
  border-radius: 11px;
  background-color: rgba(247, 249, 249, 1);
  color: rgba(145, 150, 150, 1);
  box-sizing: border-box;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}

.maxPrice {
  background-color: rgba(250, 240, 240, 1);
  color: rgba(51, 51, 51, 1);
}

.max-price-text {
  color: rgba(236, 88, 88, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
}

.min-price-text {
  color: rgba(73, 183, 107, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
}

.m-r-cart {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;

  .c-cart-icon {
    position: relative;
    cursor: pointer;

    i {
      font-size: 30px;
      color: @dh-color;
    }

    .dot {
      position: absolute;
      right: 0;
      top: -6px;
      border-radius: 8px;
      transform: translateX(50%);
      border: 2px solid #ffffff;

      p {
        padding: 0px 4px;
        font-size: 8px;
        color: #ffffff;
        background: @dh-color;
        border-radius: 8px;
      }
    }
  }
}

.c-t-head-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 5px;
}

.c-t-company-name {
  flex: 1;
  min-width: 80px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  text-align: left;
}

.c-t-labels {
  display: flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.c-t-upload-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.8;
  }
}

.c-t-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;
  flex-shrink: 0;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
}

.c-t-refresh-wrapper {
  
  .c-t-refresh-icon {
    width: 16px;
    height: 16px;
  }
}

.c-t-cart-wrapper {
  border-radius: 50%;
  
  .c-t-cart-icon {
    width: 16px;
    height: 16px;
  }
}

.section_19 {
  width: 100%;
  height: auto;
  min-height: 32px;
  margin: 21px 0;
  padding: 0 20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: visible;
}

.filter-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: nowrap;
  gap: 10px;
  box-sizing: border-box;
}

.filter-form-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.filter-form-item {
  margin-bottom: 0;
  margin-right: 6px;
}

.filter-date-picker {
  width: 170px;
}

.filter-input {
  width: 213px;
}

.filter-select {
  width: 170px;
}

.text-wrapper_10 {
  width: auto;
  height: 20px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 0 0 0 20px;
  display: flex;
  align-items: center;
}

.text_48 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_49 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(235, 73, 73, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_50 {
  display: inline-block;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.text-wrapper_9 {
  background-color: rgba(232, 250, 249, 1);
  border-radius: 4px;
  height: 32px;
  border: 1px solid rgba(72, 160, 156, 1);
  margin-left: 10px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_47 {
  width: 28px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(72, 160, 156, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
}

.text-wrapper_11 {
  background-color: rgba(72, 160, 156, 1);
  border-radius: 4px;
  height: 32px;
  margin-left: 24px;
  width: 116px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_51 {
  width: 84px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
}

.text-wrapper_12 {
  background-color: rgba(72, 160, 156, 1);
  border-radius: 4px;
  height: 32px;
  margin-left: 10px;
  width: 116px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_52 {
  width: 84px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
}

.text-wrapper_13 {
  background-color: rgba(232, 250, 249, 1);
  border-radius: 4px;
  height: 32px;
  border: 1px solid rgba(72, 160, 156, 1);
  margin-left: 10px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_53 {
  width: 28px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(72, 160, 156, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
}

.product-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
}

.product-info-row-1 {
  display: flex;
  align-items: center;
}

.product-info-row-2 {
  display: flex;
  align-items: center;
  gap: 0;
  flex-wrap: wrap;
  margin-top: 8px;
}

.section_28 {
  position: relative;
  width: auto;
  min-width: 150px;
  height: 24px;
  display: flex;
  align-items: center;
}

.text_67 {
  width: auto;
  min-width: 36px;
  max-width: 46px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(46, 114, 111, 1);
  font-size: 12px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 10px;
  z-index: 1;
  display: inline-block;
}

.text_68 {
  width: auto;
  min-width: 84px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 20px;
}

.box_8 {
  border-radius: 4px;
  position: absolute;
  left: 0;
  top: 0;
  width: 56px;
  height: 24px;
  border: 1px solid rgba(46, 114, 111, 1);
}

.text-wrapper_17 {
  width: auto;
  min-width: 155px;
  height: 18px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.text_69 {
  display: inline-block;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.text_70 {
  display: inline-block;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.text-wrapper_18 {
  width: auto;
  min-width: 135px;
  height: 18px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.text_71 {
  display: inline-block;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.text_72 {
  display: inline-block;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.text-wrapper_19 {
  width: auto;
  min-width: 76px;
  height: 18px;
  overflow-wrap: break-word;
  font-size: 0;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.text_73 {
  display: inline-block;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(145, 150, 150, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.text_74 {
  display: inline-block;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.price-tooltip-content {
  padding: 8px 12px;
  min-width: 120px;
  border-radius: 4px;
}

.price-tooltip-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  line-height: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.price-tooltip-label {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  margin-right: 8px;
  white-space: nowrap;
}

.price-tooltip-value {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  white-space: nowrap;
}

.price-original {
  text-decoration: line-through;
  color: rgba(255, 255, 255, 1);
}
.new-refresh-cart{
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.c-t-stat-number {
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  cursor: default;
  padding: 0 4px;
}
.view-btn-box{
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
  white-space: nowrap;
  margin-left: auto;
}

.floating-cart {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  cursor: pointer;
  
  .floating-cart-icon {
    position: relative;
    width: 48px;
    height: 48px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s;
    
    &:hover {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
    
    img {
      width: 28px;
      height: 28px;
      object-fit: contain;
    }
    
    .floating-cart-dot {
      position: absolute;
      right: 0;
      top: 0;
      min-width: 18px;
      height: 18px;
      border-radius: 9px;
      background-color: rgba(235, 73, 73, 1);
      border: 2px solid rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(25%, -25%);
      
      span {
        font-size: 12px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 1;
        padding: 0 4px;
      }
    }
  }
}
</style>
